import React, { PropTypes } from 'react';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import ForBuyer from './forBuyer';
import R from 'ramda';

const propTypes = {
  viewingBy: React.PropTypes.string,
  locationId: React.PropTypes.string,
  files: React.PropTypes.array,
  state: React.PropTypes.string,
  isTourPlanUser: React.PropTypes.bool,
  supplierId: React.PropTypes.string,
  messageArray: React.PropTypes.array,
  emailStatus: React.PropTypes.number,
  viewingCompanyId: React.PropTypes.string,
  buyerChecked: React.PropTypes.bool,
  isLatest: React.PropTypes.bool,
  push: React.PropTypes.func,
};

class ProgressBarContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  shouldComponentUpdate(nextProps, nextState) {
    const propKeys = R.keys(propTypes).filter(key => propTypes[key] !== PropTypes.func);
    return !R.equals(R.pick(propKeys, this.props), R.pick(propKeys, nextProps)) || !R.equals(this.state, nextState);
  }
  render() {
    const { viewingBy, ...extraProps } = this.props;
    return (
      <div style={{ marginBottom: '8px' }}>
        { viewingBy === 'Contractor' && extraProps.isLatest && extraProps.locationId ? <ForBuyer {...extraProps} /> : <div/> }
      </div>
    );
  }
}

const mapStateToProps = ({ contracting, user }) => ({
  userNameOrEmail: user.getIn(['user', 'name']) || user.getIn(['user', 'email']),
  viewingBy: user.getIn(['user', 'type']),
  viewingCompanyId: user.getIn(['company', 'companyId']),
  isTourPlanUser: Boolean(R.path(['company', 'tourplan', 'url'], user.toJS())),
  ...contracting.contractActivitiesProducts.toJS().leftNav,
  ...contracting.contractActivitiesProducts.toJS().activities,
});

const mapDispatchToProps = ({
  push,
});
ProgressBarContainer.propTypes = propTypes;
export default connect(mapStateToProps, mapDispatchToProps)(ProgressBarContainer);




// WEBPACK FOOTER //
// ./src/app/components/contracting/contract-activities-products/contract-container/progressIndicatorBar/container.jsx